
















































import { Component, Vue, Prop } from 'vue-property-decorator'

interface choice {
    img: string
    title: string
    subtitle: string
    active: boolean
}

interface choices {
    multiple: boolean
    items: Array<choice>
}

@Component({})
export default class Choices extends Vue {
    @Prop({
        default: {
            multiple: false,
            items: [],
        },
    })
    choices!: choices

    pChoices = this.choices

    toggle(item) {
        if (this.pChoices.multiple) {
            if (item.active) {
                this.unselectMultiple(item)
            } else {
                this.selectMultiple(item)
            }
        } else {
            if (!item.active) {
                this.selectUnique(item)
            }
        }
        // Émettre un événement pour notifier le parent
        this.$emit('input')
    }


    unselectMultiple(item) {
        // Permet de désélectionner l'item sans limite
        item.active = false
    }

    selectMultiple(item) {
        item.active = true
    }

    selectUnique(item) {
        for (var key in this.pChoices.items) {
            this.pChoices.items[key].active = false
        }
        item.active = true
    }
}
